import { v4 as uuidv4 } from 'uuid';

import { storage } from '~/stores/LocalStorage';

const STORAGE_KEY = 'telemetry:installId';

let cached: string | null = null;

export const getInstallId = (): string | null => {
  if (import.meta.env.SSR) {
    return null;
  }

  if (cached) {
    return cached;
  }

  try {
    cached = storage.getItem(STORAGE_KEY);

    if (!cached) {
      cached = uuidv4();
      storage.setItem(STORAGE_KEY, cached);
    }
  } catch {
    cached ??= uuidv4();
  }

  return cached;
};
